import { BASE_URL as b } from '../config/global.js'
let BASE_URL = b + '/api'
export const api = {
  domain: b,
  // 使用飞书code凭证换取token
  stGetUserToken: BASE_URL + '/index/getUserInfo2',

  stGetDiaoboList: BASE_URL + '/transfer/list',
  stGetDiaoboInfo: BASE_URL + '/transfer/info',
  stGetDiaoboView: BASE_URL + '/transfer/edit',
  stGetDiaoboEdit: BASE_URL + '/transfer/doEdit',

  stGetDiaobooList: BASE_URL + '/transfer/outlist',
  stGetDiaobooInfo: BASE_URL + '/transfer/outinfo1',
  stGetDiaobooView: BASE_URL + '/transfer/edit',
  stGetDiaobooEdit: BASE_URL + '/transfer/outDoEdit',
  stGetDiaoboQianshouList: BASE_URL + '/transfer/transferSigingInfo',
  stSetDiaoboQianshouEdit: BASE_URL + '/transfer/transferSigingEdit',
  stGetDiaoboExInfo: BASE_URL + '/transfer/getExpressInfo',
  stGetDiaoboInWHAuto: BASE_URL + '/transfer/transferInOnekeyEdit',

  stGetPandianList: BASE_URL + '/inventory/list',
  stGetPandianInfo: BASE_URL + '/inventory/info',
  stGetPandianView: BASE_URL + '/inventory/edit',
  stGetPandianEdit: BASE_URL + '/inventory/doEdit',
  stSetPandianEnd: BASE_URL + '/inventory/change_order_status',

  stGetCaigouList: BASE_URL + '/purchase/list',
  stGetCaigouInfo: BASE_URL + '/purchase/info',
  stGetCaigouView: BASE_URL + '/purchase/edit',
  stGetCaigouEdit: BASE_URL + '/purchase/doEdit',
  stGetCaigouCheck: BASE_URL + '/purchase/changQualityStatus',
  stGetCaigouQianshouList: BASE_URL + '/purchase/purchaseSigingInfo',
  stsetCaigouQianshouEdit: BASE_URL + '/purchase/purchaseSigingEdit',
  stGetCaigouExInfo: BASE_URL + '/purchase/getExpressInfo',
  stGetCaigouAuthSginfor: BASE_URL + '/purchase/purchaseSigingOnkeyEdit',
  stGetCaigouAuthIn: BASE_URL + '/purchase/purchaseInOnkeyEdit',
  stGetCaigouCreatEx: BASE_URL + '/purchase/createExpressquery',

  stGetCaigoucList: BASE_URL + '/price/list',
  stGetCaigoucView: BASE_URL + '/price/edit',
  stGetCaigoucEdit: BASE_URL + '/price/doEdit',

  stGetJiagongList: BASE_URL + '/process/list',
  stGetJiagongInfo: BASE_URL + '/process/info',
  stGetJiagongView: BASE_URL + '/process/edit',
  stGetJiagongEdit: BASE_URL + '/process/doEdit',
  stGetJiagongDoneInfo: BASE_URL + '/process/haveDoneInfo',
  stGetJiaqongDoneEdit: BASE_URL + '/process/haveDoneEdit',

  stGetJiagongcangList: BASE_URL + '/process/processWarehouseList',
  stGetJiagongcangInfo: BASE_URL + '/process/processWarehouseProducts',
  stGetJiagongcangView: BASE_URL + '/process/productWarehouseEdit',
  stGetJiagongcangEdit: BASE_URL + '/process/productWarehouseDoEdit',
  stGetJiagongcangChange: BASE_URL + '/process/changeStatusToHaveDone',

  stGetChaigongList: BASE_URL + '/disassembly/list',
  stGetChaigongInfo: BASE_URL + '/disassembly/info',
  stGetChaigongMain: BASE_URL + '/disassembly/details',
  stGetChaigongView: BASE_URL + '/disassembly/edit',
  stGetChaigongEdit: BASE_URL + '/disassembly/doEdit',
  stGetChaigongFinish: BASE_URL + '/disassembly/changeStatusToHavedo',

  // 'stGetChaigongcangList' :BASE_URL + "disassembly/disassemblyWarehouseList",
  stGetChaigongcangList: BASE_URL + '/disassembly/disassemblyWarehouseList',
  stGetChaigongcangInfo: BASE_URL + '/disassembly/disassemblyWarehouseInfo',
  stGetChaigongcangView: BASE_URL + '/disassembly/disassemblyWarehouseEdit',
  stGetChaigongcangEdit: BASE_URL + '/disassembly/disassemblyWarehouseDoEdit',

  stGetXiaoshouList: BASE_URL + '/sales/list',
  stGetXiaoshouInfo: BASE_URL + '/sales/info',
  stGetXiaoshouView: BASE_URL + '/sales/edit',
  stGetXiaoshouEdit: BASE_URL + '/sales/commit',
  stGetXiaoshouoEdit: BASE_URL + '/sales/outDoEdit',
  stGetXiaoshouoList: BASE_URL + '/sales/outlist',
  stGetXiaoshouoInfo: BASE_URL + '/sales/outinfo1',
  stGetXiaoshouCheck: BASE_URL + '/sales/setTestingState',
  stGetXiaoshouExInfo: BASE_URL + '/sales/getExpressInfo',
  // 更新物流信息(海外)
  stUpdataExInfo: BASE_URL + '/sales/editExpress',

  // 销售统计
  // 租赁统计
  stGetXiaoshouStatistics: BASE_URL + '/statistics/salelist',

  stGetIndexFirstPage: BASE_URL + '/index/firstPage',

  stGetJiagongLingliaoList: BASE_URL + '/warehouse/processOutboundList',
  stSetJiagongLingliaoDoedit: BASE_URL + '/warehouse/processOutbound',

  stGetChaigongLingliaoList: BASE_URL + '/warehouse/disassemblyOutboundList',
  stSetChaigongLingliaoDoedit: BASE_URL + '/warehouse/disassemblyOutbound',

  // 签收确认
  stGetQianshouList: BASE_URL + '/signing/transferSigningOrderList',
  stSetQianshouEdit: BASE_URL + '/signing/transferSigningDoEdit',
  stSetQianshouInfoList: BASE_URL + '/signing/transferSigningInfoList',
  stSetQianshouAuth: BASE_URL + '/signing/onekeySigningDoEdit',

  // 物流公司
  stGetExList: BASE_URL + '/express/pickexpress',

  // 我的采购单
  stGetCaigoudanList: BASE_URL + '/purchase/purList',
  stGetCaigoudanInfo: BASE_URL + '/purchase/purInfo',

  // 下架工单
  stGetXiajiagongdanList: BASE_URL + '/scrapped/list',
  stGetXiajiagongdanInfo: BASE_URL + '/scrapped/info',
  stGetXiajiagongdanEditTime: BASE_URL + '/scrapped/edittime',
  stGetXiajiagongdanConfirm: BASE_URL + '/scrapped/commit',

  // keyword
  stGetFeedbackList: BASE_URL + '/inventory_position/search',

  // 采购入库快速
  stGetCaigouoShortcut: BASE_URL + '/purchase/onekeyin',
  // 调拨入库快速
  stGetDiaobooShortcut: BASE_URL + '/transfer/onekeyin',
  // 加工入库快速
  stGetJiagongoShortcut: BASE_URL + '/process/onekeyin',
  // 拆工入库快速
  stGetChaigongoShortcut: BASE_URL + '/disassembly/onekeyin',

  // 销售出库审批
  stOutApprove: BASE_URL + '/sales/outApprove',

  // 库存统计数据与搜索类型
  stGetKucuntongji: BASE_URL + '/inventory/statistics',
  // 库存管理列表
  stGetKucuntongjiList: BASE_URL + '/inventory/index',
  // 库存详情
  stGetKucunxiangqing: BASE_URL + '/inventory/detail',

  // 库存资产
  stGetKucunzichan: BASE_URL + '/inventory/statisticsAssets',
  // 库存资产列表
  stGetKucunzichanList: BASE_URL + '/inventory/indexAssets',
  // 修改库存资产
  stGetKucunzichanEdit: BASE_URL + '/inventory/inventoryAssetsPrice',

  // 库存成本
  stGetKucunchengben: BASE_URL + '/inventory/statisticsCost',
  // 库存成本列表
  stGetKucunchengbenList: BASE_URL + '/inventory/indexCost',
  // 修改库存成本
  stGetKucunchengbenEdit: BASE_URL + '/inventory/inventoryCostPrice',

  // 采购供应商列表
  stGetSupplierList: BASE_URL + '/purchasing_supplier_statistics/supplierList',
  // 供应商汇总数据
  stGetSupplierAll: BASE_URL + '/purchasing_supplier_statistics/summary',
  // 供应商详情数据
  stGetSupplierInfo: BASE_URL + '/purchasing_supplier_statistics/detail',
  // 供应商本月代付款列表
  stGetSupplierOrderList: BASE_URL + '/purchasing_supplier_statistics/mouthPayList',

  // 采购员
  stGetBuyerInfo: BASE_URL + '/purchasing_buyer_statistics/buyersummary',
  stGetBuyerList: BASE_URL + '/purchasing_buyer_statistics/buyerList',
  stGetBuyerById: BASE_URL + '/purchasing_buyer_statistics/buyerdetail',
  stGetBuyerOrdelist: BASE_URL + '/purchasing_buyer_statistics/purchaseOrderLists',

  // 销售-客户统计汇总
  stGetCustomerAll: BASE_URL + '/sale_client_statistics/summary',
  // 销售-客户统计列表
  stGetCustomerList: BASE_URL + '/sale_client_statistics/clientidList',
  // 销售-客户统计详情
  stGetCustomerInfo: BASE_URL + '/sale_client_statistics/detail',
  // 销售-客户 客户本月待付款列表
  stGetCustomerOrderList: BASE_URL + '/sale_client_statistics/mouthInList',

  // 租赁-统计汇总
  stGetLeaseCustomerAll: BASE_URL + '/lease_client_statistics/summary',
  // 租赁-客户统计列表
  stGetLeaseCustomerList: BASE_URL + '/lease_client_statistics/clientidList',
  // 租赁-客户统计详情
  stGetLeaseCustomerInfo: BASE_URL + '/lease_client_statistics/detail',
  // 租赁-客户 客户本月待付款列表
  stGetLeaseCustomerOrderList: BASE_URL + '/lease_client_statistics/mouthInList',

  // 销售-团队汇总
  stGetSaleTeamAll: BASE_URL + '/sale_seller_statistics/sellersummary',
  // 销售团队列表
  stGetSaleTeamAllList: BASE_URL + '/sale_seller_statistics/sellerTeamList',
  // 销售-团队总计
  stGetSaleTeamInfo: BASE_URL + '/sale_seller_statistics/sellerTeamDetail',
  // 销售-团队成员列表
  stGetSaleMemberList: BASE_URL + '/sale_seller_statistics/buyerList',
  // 销售-个人详情
  stGetMemberInfo: BASE_URL + '/sale_seller_statistics/sellerdetail',
  // 销售-个人订单列表
  stGetMemberOrderList: BASE_URL + '/sale_seller_statistics/purchaseOrderLists',

  // 租赁-团队汇总
  stGetLeaseTeamAll: BASE_URL + '/lease_seller_statistics/sellersummary',
  // 租赁-团队列表
  stGetLeaseTeamAllList: BASE_URL + '/lease_seller_statistics/sellerTeamList',
  // 租赁-团队总计
  stGetLeaseTeamInfo: BASE_URL + '/lease_seller_statistics/sellerTeamDetail',
  // 租赁-团队成员列表
  stGetLeaseMemberList: BASE_URL + '/lease_seller_statistics/buyerList',
  // 租赁-个人详情
  stGetLeaseMemberInfo: BASE_URL + '/lease_seller_statistics/sellerdetail',
  // 租赁-个人订单列表
  stGetLeaseMemberOrderList: BASE_URL + '/lease_seller_statistics/purchaseOrderLists',

  // 查看工资列表
  stGetSalaryList: BASE_URL + '/salar/salaryList',
  // 查看工资详情
  stGetSalaryInfo: BASE_URL + '/salar/salaryDetail',

  // 申请临时额度
  stGetCreditUp: BASE_URL + '/sale_client_statistics/quota_approval',

  // sku 采购 头部分类模块
  stGetSkuStatisticsCost: BASE_URL + '/product/statisticsCost',
  // sku 销售 头部分类模块
  stGetSkuStatisticsAssets: BASE_URL + '/product/statisticsAssets',
  // sku 采购统计列表
  stSkuPurchaseList: BASE_URL + '/product/purCost',
  // sku 销售统计列表
  stSkuSalesList: BASE_URL + '/product/saleAssets',

  // 获取审批单据
  stGetApprovalInfo: BASE_URL + '/enterprise_we_chat_approval/get_approval_info',

  // 采购单列表
  stPurchaseList: BASE_URL + '/purchase/purList',

  // 采购单详情
  stPurchaseInfo: BASE_URL + '/purchase/purInfo',

  // 获取编辑信息
  stPurchaseUpdate: BASE_URL + '/purchase/update/id',

  // 采购提交
  stPurchaseStore: BASE_URL + '/purchase/store',

  // 提交采购单审核
  stPurchaseApproval: BASE_URL + '/purchase/approval',

  // 公司
  stCompanyList: BASE_URL + '/company/select_company',

  // 付款账户
  stCorporation: BASE_URL + '/corporation/select_corporation',

  // 采购人员
  stPurchaseUser: BASE_URL + '/purchase/purchase_user_list',

  // 采购供应商
  stPurchaseSupplier: BASE_URL + '/supplier/select_supplier',

  // 币种
  stCurrency: BASE_URL + '/parm/select_currency',


  // 采购单产品
  stPurchaseSku: BASE_URL + '/product/purchase_sku_select',

  // 仓库
  stWarehouse: BASE_URL + '/warehouse/warehouse_select',

  // 客户
  stCustomer: BASE_URL + '/customer/select_customer',

  // 采购单入库单详情
  stEnterStoreDetail: BASE_URL + '/purchase/receipt_detail',

  // 采购入库
  stEnterStore: BASE_URL + '/purchase/purchase_receipt/id/',



    /* -----------------------------------------------------------------------这是一条帅气的分割线----------------------------------------------------------------------------- */

    // 服务查询
    // stEnterStore: BASE_URL + '/purchase/purchase_receipt/id/',

    // 四通报修工单
    stRmaOrderSelect: BASE_URL + '/ramorder/select',

    stRmaOrderAdd: BASE_URL + '/ramorder/add',

      // 上传文件
    stUpload: BASE_URL + '/file/upload',


    // 评价
    stRmaOrderEvaluate: BASE_URL + '/ramorder/evaluate',

    // 获取 首页背景图
    stDashboardBackground: BASE_URL + '/ramorder/getImageCover',
}
